import { render, staticRenderFns } from "./OrderLogs.vue?vue&type=template&id=31f81eda&scoped=true&"
import script from "./OrderLogs.vue?vue&type=script&lang=js&"
export * from "./OrderLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f81eda",
  null
  
)

export default component.exports